<template>
  <div class="page">
    <h2>История</h2>
    <div class="vm-card">
      <div v-if="appointments.length || loading" class="vm-history-list">
        <div v-if="!loading">
          <div
            v-for="appointment in appointments"
            class="vm-history-item"
            :key="appointment.id"
          >
            <div class="vm-history-doctor">
              <div class="vm-history-doctor-name">{{ appointment.name }} <em style="font-size:14px; color:gray">({{appointment.status}})</em></div>
              <div class="vm-history-doctor-specialty">
                {{ appointment.specialty }}
              </div>
            </div>
            <div class="vm-history-timestamp">
              <div class="vm-history-timestamp-value">
                {{ appointment.time }}
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div
            v-for="item in loadingItems"
            :key="item"
            class="vm-history-item vm-history-item-loading"
          >
            <div class="vm-history-doctor">
              <div class="vm-history-doctor-name loading-block"></div>
              <div class="vm-history-doctor-specialty loading-block"></div>
            </div>
            <div class="vm-history-timestamp">
              <div class="vm-history-timestamp-value loading-block"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="vm-history-empty">
        Нет записей к врачу
      </div>
    </div>
  </div>
</template>

<script>
import { patientApi } from '../../../services';
import moment from 'moment';

export default {
  data: () => ({
    appointments: [],
    loading: false,
    loadingItems: Array.from(new Array(5)).map((v, i) => i)
  }),
  async created() {
    this.loading = true;
    const { items } = await patientApi.getAppointments();
    this.appointments = items.map(({ uuid, doctor, start_time, end_time, status }) => {
      const name = `${doctor.employee.lastName} ${doctor.employee.firstName} ${doctor.employee.middleName}`;
      const time = `${moment(start_time).format('DD.MM.YYYY LT')}-${moment(
        end_time
      ).format('LT')}`;
      return {
        uuid,
        name,
        time,
        specialty: doctor.specialty.title,
        status
      };
    });
    this.loading = false;
  }
};
</script>

<style scoped>
h2 {
  color: #727272;
  margin-bottom: 2rem;
  font-size: 1.5rem;
}
.vm-card {
  border-radius: 4px;
  background-color: white;
  background-color: #fff;
  border-radius: 0.25rem;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
}
.vm-history-empty {
  font-size: 1.2em;
  font-weight: 300;
  color: #6c757d;
}
.vm-history-item {
  padding: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  display: flex;
}
.vm-history-item:last-child {
  border-bottom: 0;
}
.vm-history-doctor {
  margin-right: auto;
}
.vm-history-doctor-name {
  font-size: 1.5rem;
  color: #212529;
  line-height: 1.2;
  margin-bottom: 0.5rem;
}
.vm-history-doctor-specialty {
  color: #6c757d;
}
.vm-history-timestamp {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.vm-history-timestamp-label {
  color: #6c757d;
  font-size: 0.8rem;
}

.vm-history-timestamp-value {
  color: #6cbdee;
  font-weight: 600;
}
.vm-history-item-loading .vm-history-doctor-specialty {
  width: 150px;
  height: 24px;
}
.vm-history-item-loading .vm-history-doctor-name {
  width: 350px;
  height: 28px;
}
.vm-history-item-loading .vm-history-timestamp-value {
  width: 200px;
  height: 24px;
}
.loading-block {
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #ececec;
  background: linear-gradient(to right, #f7f7f7 8%, #ececec 38%, #f7f7f7 54%);
  background-size: 1000px 640px;
  position: relative;
}
</style>
